// extracted by mini-css-extract-plugin
module.exports = {"container":"pg-draft_container__2yDuM","title":"pg-draft_title__3vmQd","draft":"pg-draft_draft__nYUev","paragraph":"pg-draft_paragraph__3E6Wz"};